var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 9"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M1.13 0C.635 0 .292.222.102.666c-.19.443-.114.825.229 1.145L7.7 8.68c.228.212.494.319.799.319.305 0 .571-.107.8-.32l7.37-6.87c.342-.319.418-.7.228-1.144C16.708.222 16.365 0 15.87 0H1.13z"}})])};var toString = function () {return "/app/static/svg/icon_hidden_share.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./static/svg/icon_hidden_share.svg
// module id = 1074
// module chunks = 39 80